import Parameter from "./Parameter"
class AudioUnit {

	constructor(type, name, path) {
		this.type = type;
		this.name = name;
		this.path = path;
		this.params = new Map();
	}

	createNodes(context, previousUnit) {
		console.error("Not implemented")
	}

	createParameter(name, options) {
		var param = new Parameter(Object.assign({
			path: this.path + "_PARAM_" + name.toUpperCase(),
			name: name
		}, options || {}));
		this.params.set(name, param);
		return param;
	}

	getParameters() {
		return this.params;
	}

	getParameterByName(name) {
		return this.params.get(name);
	}

	setParameterValue(name, value) {
		if(this.params.has(name)) {
			this.params.get(name).setValue(value);
			return true;
		}
		return false;

	}

	rehydrate(state) {
		for (var i in state.params) {
			if (state.params.hasOwnProperty(i)) {
				this.setParameterValue(i, state.params[i]);
			}
		}
	}

	dehydrate() {
		var paramsData = {};
		for (let pair of this.params) {
			paramsData[pair[0]] = pair[1].value;
		}
		return {
			type: this.type,
			params: paramsData,
			path: this.path
		};
	}

	playSample(context, output, name, time) {
		var source = context.createBufferSource();
		source.buffer = AudioUnit.sample_cache.get(name);
		source.connect(output);
		source.start(time);
	}

	playSingleSample(context, output, name, time) {
		if(this.singleSource) {
			this.singleSource.stop(time);
		}

		this.singleSource = context.createBufferSource();

		this.singleSource.buffer = AudioUnit.sample_cache.get(name);
		this.singleSource.connect(output);
		this.singleSource.start(time);
	}

	loadSamples(context, names) {
		return Promise.all(names.map((name) => {
			return this.loadSample(context, name);
		})).then(function(buffers){

			buffers.forEach(function(buffer){
				if(!buffer.cached) {
					AudioUnit.sample_cache.set(buffer.name, buffer.buffer);
				}
			});

		}).catch(function(reason){
			console.error(reason)
		})
	}

	loadSample(context, name) {

		return new Promise(function(resolve, reject){

			if(AudioUnit.sample_cache.has(name)) {
				resolve({ cached: true });
			}

			let pathPath = window.location.pathname;

			let request = new XMLHttpRequest();
			request.open("GET", pathPath.substring(0, pathPath.lastIndexOf("/")) + "/samples/" + name, true);
			request.responseType = "arraybuffer";

			request.onload = () => {
				// Asynchronously decode the audio file data in request.response
				context.decodeAudioData(
					request.response,
					function (buffer) {
						if (!buffer) {
							reject('error decoding file data: ' + name);
							return;
						}
						resolve({
							buffer,
							name
						});
					},
					function (error) {
						reject(error);
					}
				);
			};
			request.send();
		});

	}

}

AudioUnit.sample_cache = new Map();

export default AudioUnit;
